module.exports = __webpack_public_path__ + "img/canton-logo-en.5ea8150d.svg";